import cashBookInstance from '../../cashBook/instance'

const getCashActiveStatus = () => {
	return cashBookInstance.get('/cash-book/active-status')
}

export default getCashActiveStatus
